import moment from 'moment';
import { Fragment, h } from 'preact';

import Content from './content';
import dates from './dates.json';
import Footer from './footer';
import Navbar from './navbar';

const Home = () => (
  <Fragment>
    <Navbar />

    <div className="intro-page scrollspy" id="intro">
      <div className="background-scene-background"></div>
      <div className="woc-heading">Winter of Code</div>
      <div className="woc-subheading">
        A month long coding & designing extravaganza
        <br /> for beginners organized by SDSLabs, IIT Roorkee
      </div>
      <img
        src="../../assets/images/horizontal-bar.svg"
        className="horizontal-bar"
      />
      {/*<div className="woc-subheading">Registrations opening soon!</div>*/}
      {/* <a
        href={
          moment().isBefore(dates['proposals-released'].toString())
            ? '/register'
            : '/results'
        }
        className="woc-button"
      >
        <button id="register-button" type="button">
          {moment().isBefore(dates['proposals-released'].toString())
            ? 'Register'
            : 'Results'}
        </button>
      </a>*/} 
      <a
        href=''
        className="woc-button"
      >
        <button id="register-button" type="button" disabled>
          Registrations Closed
        </button>
      </a> 
      {/* <a 
        href={
          '/results'
        }
        className="woc-button"
        style="margin-top: 1.5rem;"
      >
        <button id="register-button" type="button">
          {'Last Year Results'}
        </button>
      </a> */}
    </div>

    <Content />

    <Footer />
  </Fragment>
);

export default Home;
